import React from 'react';
import { Link } from 'react-router-dom';

import './nomatch.css'

const NoMatch = () => {
    return (
        <div className="nomatch">
        <p className="nomatch__text">Error 404: la page que vous cherchez n'existe pas</p>
        <Link to='/'><button>retourner a l'acceuil</button></Link>
        </div>
    );
};

export default NoMatch;